// extracted by mini-css-extract-plugin
module.exports = {"sectionLoing":"Index_sectionLoing_AM3zL"};